import { gql } from '@apollo/client';

const isMcpGloballyEnabled = gql`
  query IsMcpGloballyEnabled {
    isMcpGloballyEnabled
  }
`;

export default isMcpGloballyEnabled;
